import { render, staticRenderFns } from "./OnHold.vue?vue&type=template&id=946fc6f8&scoped=true"
import script from "./OnHold.vue?vue&type=script&lang=js"
export * from "./OnHold.vue?vue&type=script&lang=js"
import style0 from "./OnHold.vue?vue&type=style&index=0&id=946fc6f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946fc6f8",
  null
  
)

export default component.exports